export const advancedRevisionSteps = [
  'intro',
  'select-text',
  'add-comment',
  'edit-comment',
  'general-feedback',
  'confirm'
];

const state = {
  initialized: false,
  currentTour: undefined,
  currentStep: undefined,
  completedTours: [],
  steps: [],
};

const getters = {
  showTour: (state) => state.initialized && !state.completedTours.includes(state.currentTour),
  showTourStep: (state, getters) => ({ tourId, step }) => getters.showTour && state.currentTour === tourId && state.currentStep === step,
  showTourIntro: (state, getters) => (tourId) => getters.showTourStep({ tourId, step: 'intro' }),
  currentStep: (state) => state.currentStep,
  currentStepNumber: (state) => Math.max(state.steps.indexOf(state.currentStep), 0) + 1,
  totalSteps: (state) => state.steps.length,
  canGoToPrevStep: (state, getters) => getters.currentStepNumber > 1,
};

const actions = {
  init: async ({state, commit}, {tourId, steps}) => {
    const firstStep = steps[0];
    if (!firstStep) {
      throw new Error('Tour must have at least one step');
    }

    commit('setSteps', steps);
    commit('setTour', {tourId, step: firstStep});


    const completedToursResponse = await axios.get('/ajax/v2/user-tours');
    commit('setCompletedTours', completedToursResponse.data.data);

    commit('setInitialized', true);
  },
  markTourCompleted: async ({commit, getters, state}, tourId) => {
    const completedTours = state.completedTours;
    if (completedTours.includes(tourId)) {
      return;
    }

    completedTours.push(tourId);
    await axios.post('/ajax/v2/user-tours', {tour_id: tourId, last_step: state.currentStep});

    commit('setCompletedTours', completedTours);
    commit('clearCurrentTour');
  },

  goToNextStep: ({ state, commit, dispatch }) => {
    const currentStepIndex = Math.max(state.steps.indexOf(state.currentStep), 0);
    const nextStepIndex = currentStepIndex + 1;

    if (!state.steps[nextStepIndex]) {
      return dispatch('markTourCompleted', state.currentTour);
    }

    commit('setCurrentStep', state.steps[nextStepIndex]);
  },
};

const mutations = {
  setCompletedTours: (state, completedTours) => state.completedTours = completedTours,

  setSteps: (state, steps) => state.steps = steps,

  setInitialized: (state, initialized) => state.initialized = initialized,

  setTour: (state, { tourId, step }) => {
    state.currentTour = tourId;
    state.currentStep = step;
  },

  clearCurrentTour: (state) => {
    state.currentTour = undefined;
    state.currentStep = undefined;
  },

  setCurrentStep: (state, step) => {
    state.currentStep = step;
  },

  goToPrevStep: (state) => {
    const currentStepIndex = Math.max(state.steps.indexOf(state.currentStep), 0);
    const prevStepIndex = currentStepIndex - 1;

    if (!state.steps[prevStepIndex]) {
      throw new Error('Tour has no more prev step');
    }

    state.currentStep = state.steps[prevStepIndex];
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};